import { createContext, useContext } from 'react';
import { LooseObject } from 'services/interface';

type WorkshopDiscountContextParams = {
  showDiscount?: boolean;
  discount: number;
  queryObject?: LooseObject;
};

const WorkshopDiscountContext = createContext<WorkshopDiscountContextParams>({
  showDiscount: false,
  discount: 1,
  queryObject: {}
});

export const useWorkshopDiscountContext = () => {
  const context = useContext(WorkshopDiscountContext);

  if (!context) {
    throw new Error(
      'useWorkshopEventOccurrenceContext must be used inside WorkshopEventOccurrenceContextProvider'
    );
  }

  return context;
};

export default WorkshopDiscountContext;
